// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";

function isReactNativeWebView() {
  return Core__Option.isSome(window.ReactNativeWebView);
}

function sendPostMessage($$event) {
  var webView = window.ReactNativeWebView;
  if (webView !== undefined) {
    Caml_option.valFromOption(webView).postMessage(JSON.stringify($$event));
    return ;
  }
  
}

var SendMessageEvent = {
  sendPostMessage: sendPostMessage
};

function receiveMessage($$event) {
  var webView = window.ReactNativeWebView;
  if (webView !== undefined) {
    Caml_option.valFromOption(webView).postMessage(JSON.stringify($$event));
    return ;
  }
  
}

var RecieveMessageEvent = {
  receiveMessage: receiveMessage
};

function use(onMessage) {
  React.useEffect((function () {
          if (onMessage !== undefined) {
            window.addEventListener("message", onMessage);
            return (function () {
                      window.removeEventListener("message", onMessage);
                    });
          }
          
        }), [onMessage]);
}

var EventListener = {
  use: use
};

export {
  isReactNativeWebView ,
  SendMessageEvent ,
  RecieveMessageEvent ,
  EventListener ,
}
/* react Not a pure module */
